import { Star, Quote } from "lucide-react";
import { REVIEWS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const Stars = () => (
    <span className="flex items-center gap-0.5" aria-label="5 de 5 estrellas">
        {[...Array(5)].map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-gold text-gold" />
        ))}
    </span>
);

export const Reviews = () => (
    <section id="resenas" data-testid="reviews-section" className="scroll-mt-20 bg-white py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold">
                    03 · Reseñas verificadas
                </p>
                <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
                    Lo que dicen nuestros clientes
                </h2>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-testid="reviews-grid">
                {REVIEWS.map((review, index) => (
                    <Reveal key={review.id} delay={index * 0.08} className="h-full">
                        <figure
                            data-testid={`review-card-${review.id}`}
                            className="flex h-full flex-col rounded-md border border-ink/10 bg-white p-8 shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/10"
                        >
                            <Quote className="h-6 w-6 text-gold/40" />
                            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-gray-700">
                                “{review.text}”
                            </blockquote>
                            <figcaption className="mt-6 flex items-center justify-between border-t border-ink/10 pt-5">
                                <Stars />
                                <span className="text-xs font-semibold uppercase tracking-wide text-gray-400">
                                    Reseña de Google
                                </span>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>

            <Reveal className="mt-12">
                <div
                    data-testid="google-rating-badge"
                    className="mx-auto flex max-w-xl flex-col items-center gap-3 rounded-md border border-ink/10 bg-white px-8 py-6 shadow-sm sm:flex-row sm:justify-center sm:gap-6"
                >
                    <span className="font-display text-5xl font-extrabold text-ink">4,7</span>
                    <div className="flex flex-col items-center gap-1 sm:items-start">
                        <Stars />
                        <p className="text-sm font-semibold text-gray-600">
                            (13 reseñas) — Servicio de Lavado de Coches
                        </p>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
